<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { logger } from '@/utils/logger'

const router = useRouter()
const authStore = useAuthStore()

onMounted(async () => {
  try {
    logger.info('Auth callback mounted, processing authentication...')
    
    // Hash fragment'ı URL'den al ve process et
    const hash = window.location.hash.substring(1)
    logger.info('Auth hash:', { hashLength: hash.length })
    
    if (hash) {
      // URLSearchParams ile fragment'i parse et
      const hashParams = new URLSearchParams(hash)
      const accessToken = hashParams.get('access_token')
      const expiresIn = hashParams.get('expires_in')
      const refreshToken = hashParams.get('refresh_token')
      const providerToken = hashParams.get('provider_token')
      
      if (accessToken) {
        logger.info('Found access token in URL, setting session manually', {
          tokenLength: accessToken.length,
          expiresIn
        })
        
        try {
          // Supabase session'ı localStorage'a manuel kaydet
          const sessionData = {
            access_token: accessToken,
            expires_in: Number(expiresIn) || 3600,
            refresh_token: refreshToken || '',
            provider_token: providerToken || '',
            token_type: 'bearer'
          }
          
          window.localStorage.setItem('supabase.auth.token', JSON.stringify(sessionData))
          logger.info('Successfully stored auth token in localStorage')
          
          // AuthStore kullanarak session'ı yenile
          await authStore.checkUser()
          
          // Router ile güvenli yönlendirme
          logger.info('Redirecting to channels page...')
          router.push('/channels')
          return
        } catch (tokenError) {
          logger.error('Error processing token:', tokenError)
          // Token işlemede hata olsa bile devam et
        }
      }
    }
    
    // Code parametresi kontrolü (Auth Code flow için)
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    if (code) {
      logger.info('Found auth code, continuing normal flow')
    }
    
    // Normal session kontrolü
    await authStore.checkUser()
    
    if (authStore.user) {
      logger.info('User authenticated, redirecting to channels', {
        userId: authStore.user.id,
        email: authStore.user.email
      })
      router.push('/channels')
    } else {
      logger.error('No user found after auth callback')
      router.push('/')
    }
  } catch (error) {
    logger.error('Error in auth callback:', error)
    router.push('/')
  }
})
</script>

<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center">
      <h2 class="text-2xl font-semibold mb-4">Giriş yapılıyor...</h2>
      <div class="animate-spin rounded-full h-12 w-12 border-4 border-accent border-t-transparent mx-auto"></div>
    </div>
  </div>
</template> 